import { IPartFinderSelection } from 'partFinder/types';

const SELECTION_PARAM = 's';

export const EMPTY_SELECTION: IPartFinderSelection = {
  inStock: false,
  locationIds: [],
  manufacturerIds: [],
  numbers: {},
  values: {},
};

// The narrowing travels in the query string so the pages can be reloaded and shared.
export const selectionToSearch = (selection: IPartFinderSelection): string =>
  `?${SELECTION_PARAM}=${encodeURIComponent(JSON.stringify(selection))}`;

const toNumberArray = (value: unknown): number[] =>
  Array.isArray(value) ? value.map(Number).filter(Number.isFinite) : [];

const toStringArray = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];

const toRecord = <T>(value: unknown, toEntry: (item: unknown) => T | null): Record<number, T> =>
  Object.fromEntries(
    Object.entries(value && typeof value === 'object' ? value : {})
      .filter(([key]) => Number.isFinite(Number(key)))
      .map(([key, item]) => [key, toEntry(item)] as const)
      .filter((entry): entry is readonly [string, T] => entry[1] !== null)
  );

// A hand-edited or cut-off link gives an empty narrowing, never a shape the pages cannot read.
export const selectionFromSearch = (search: string): IPartFinderSelection => {
  try {
    const parsed = JSON.parse(new URLSearchParams(search).get(SELECTION_PARAM) ?? '');

    return {
      inStock: Boolean(parsed?.inStock),
      locationIds: toNumberArray(parsed?.locationIds),
      manufacturerIds: toNumberArray(parsed?.manufacturerIds),
      numbers: toRecord(parsed?.numbers, (item) =>
        typeof item === 'string' || typeof item === 'number' ? String(item) : null
      ),
      values: toRecord(parsed?.values, (item) => {
        const values = toStringArray(item);

        return values.length ? values : null;
      }),
    };
  } catch {
    return EMPTY_SELECTION;
  }
};
